import React, { useEffect, useRef } from "react";
//import "../../styles/App.css"; // Asegúrate de importar tus estilos aquí

const CustomOffCanvas = ({
                             id = "customOffCanvas",
                             title = "Details",
                             children,
                             isOpen,
                             onClose,
                             width = "custom-offcanvas-wide", // clase que puedes personalizar en App.css
                         }) => {
    const ref = useRef(null);

    useEffect(() => {
        if (isOpen) {
            ref.current?.classList.add("open");
        } else {
            ref.current?.classList.remove("open");
        }
    }, [isOpen]);

    return (
        <div ref={ref} id={id} className={`custom-offcanvas ${width}`}>
            <div className="custom-offcanvas-header">
                <h5 className="fw-bold">{title}</h5>
                <button
                    className="btn btn-outline-secondary ms-auto"
                    onClick={onClose}
                >
                    <i className="bi bi-x-lg"></i>
                </button>
            </div>

            <div className="custom-offcanvas-body">{children}</div>
        </div>
    );
};

export default CustomOffCanvas;
